
<template>
  <div class="co2calc ce_form">

		<div :class="['co2calc__topbar', { sticky: isSticky }]">
			<span>{{ Math.round(pathStyleEnergyConsumption.percentage) }}%<small>{{lang.savings}}</small></span>
			<span class="hide-mobile">{{ formatNumber(energyConsumptionDifference) }} kWh <small>{{ lang.savings }}</small></span>
			<span class="hide-mobile">{{ formatNumber(energyCostDifference) }} CHF <small>{{ lang.savings }}</small></span>
			<span>{{ formatNumber(co2EmissionsDifference) }} kg <small>CO<sub>2</sub> {{ lang.savings }}</small></span>
		</div>

			<section class="co2calc__section co2calc__section--result" v-if="currentStep >= 3">
				<h2 class="co2calc__section-title">{{ lang.maintitle }}</h2>

				<div class="error-overlay"
					v-if="!lightingSystems[1].systemPower || !lightingSystems[0].systemPower || !customEnergyMix || !lightPoints || !operatingHours || !electricityCost || (energyMix == 0 && customEnergyMix < 0)"
				>
					{{ lang.erroremptyfields }}
				</div>

				<div class="co2calc__savings">
					<div class="co2calc__savings-section">
						<div class="infographic infographic--stats">
							<span class="infographic__legend">{{ Math.round(pathStyleEnergyConsumption.percentage) }}% <span class="infographic__legend-subtext">{{lang.savings}}</span> </span>
							<svg class="infographic__bg" width="100%" height="100%" viewBox="0 0 276 276" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path
										d="M138 273C212.558 273 273 212.558 273 138C273 63.4416 212.558 3 138 3C63.4416 3 3 63.4416 3 138C3 212.558 63.4416 273 138 273Z"
										stroke="#eeeeee"
										stroke-width="6"
										stroke-linecap="round"
										stroke-linejoin="round"
									/>
							</svg>
							<svg class="infographic__active" width="100%" height="100%" viewBox="0 0 276 276" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path
										d="M138 273C212.558 273 273 212.558 273 138C273 63.4416 212.558 3 138 3C63.4416 3 3 63.4416 3 138C3 212.558 63.4416 273 138 273Z"
										stroke="#FFBC00"
										stroke-width="6"
										stroke-linecap="round"
										stroke-linejoin="round"
										:style="pathStyleEnergyConsumption.pathStyle"
									/>
							</svg>
						</div>
					</div>
					<div class="co2calc__savings-section">
						<div class="infographic infographic--stats">
							<img src="/files/elektron/icons/energyconsumption.gif" class="infographic__icon" alt="energieverbrauch icon">
						</div>
						<div class="co2calc__savings-legend">
							<span>{{lang.saving}} {{lang.energyconsumption}}</span>
							<span class="co2calc__savings-legend-main">{{ formatNumber(energyConsumptionDifference) }}</span>
							<span> kWh</span>
						</div>
					</div>
					<div class="co2calc__savings-section">
						<div class="infographic">
							<img src="/files/elektron/icons/energycost.gif" class="infographic__icon" alt="energiekostenersparnis icon">
						</div>
						<div class="co2calc__savings-legend">
							<span>{{lang.saving}} {{lang.energycosts}}</span>
							<span class="co2calc__savings-legend-main">{{ formatNumber(energyCostDifference) }}</span>
							<span> CHF</span>
						</div>
					</div>
					<div class="co2calc__savings-section">
						<div class="infographic infographic--stats">
							<img src="/files/elektron/icons/co2saving.gif" class="infographic__icon" alt="co2ersparnis icon">
						</div>
						<div class="co2calc__savings-legend">
							<span>{{lang.saving}} CO<sub>2</sub>-{{lang.exhaust}}</span>
							<span class="co2calc__savings-legend-main">{{ formatNumber(co2EmissionsDifference) }}</span>
							<span> kg CO<sub>2</sub></span>
						</div>
					</div>
				</div>

				<div style="text-align: center;">
					<br>
					<button @click="openRequestform" class="button button--primary submit co2-submit" :class="{ 'button--visible': hasChanges }">{{lang.sendresultemail}}</button>
				</div>
    </section>

		<section class="co2calc__section" style="margin-top: 2em;">
			<div class="widget widget--timeframe">
        <label for="timeframe"><b>{{ lang.timeframe }}</b></label>
        <input type="range" class="range-input" id="timeframe" v-model.number="timeframe" min="1" max="20" />
        {{ timeframe }} {{ timeframe > 1 ? lang.years : lang.year }}
      </div>
		</section>

    <section class="co2calc__section co2calc__section--lightingsystem" v-if="currentStep >= 2">
      <h2 class="co2calc__section-title">{{lang.lightingsystems}}</h2>
      <div
        v-for="(system, index) in lightingSystems"
        :key="index"
        class="co2calc__lightingsystem"
      >
        <h3 class="co2calc__section-subtitle">{{ index == 0 ? lang.existingsystem : lang.newsystem }}</h3>
        <div class="widget widget-text">
					<input
					type="number"
					min="0"
					:id="`system_power_${index}`"
					v-model.number="system.systemPower"
					:class="{ 'error': !system.systemPower }"
          />
          <label :for="`system_power_${index}`">{{lang.systempower}}</label>
        </div>
        <div class="widget">
          <label class="info_icon" :for="`dimming_factor_${index}`">
						<span>{{lang.dimmingfactor}}</span>
						<svg @click.prevent="toggleOverlay(true)" width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M15.6666 29.6667C23.5827 29.6667 29.9999 23.2494 29.9999 15.3333C29.9999 7.41725 23.5827 1 15.6666 1C7.7505 1 1.33325 7.41725 1.33325 15.3333C1.33325 23.2494 7.7505 29.6667 15.6666 29.6667Z" stroke="#555F69" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M15.6666 11.04C16.403 11.04 16.9999 10.4431 16.9999 9.70669C16.9999 8.97031 16.403 8.37335 15.6666 8.37335C14.9302 8.37335 14.3333 8.97031 14.3333 9.70669C14.3333 10.4431 14.9302 11.04 15.6666 11.04Z" fill="#555F69"/>
							<path d="M15.6665 13.1467V22.2867" stroke="#555F69" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</label>
          <select v-model="system.dimmingFactor" :id="`dimming_factor_${index}`">
            <option value="1">1</option>
            <option value="0.7">0.7</option>
            <option value="0.55">0.55</option>
            <option value="0.4">0.4</option>
            <option value="0">{{ lang.choose }}</option>
          </select>

					<div class="widget widget--timeframe widget--timeframe-dimming" v-if="system.dimmingFactor == 0">
						<label :for="`custom_dimming_factor_${index}`">{{lang.choosedimmingfactor}}</label>
						<input type="range" class="range-input" id="`custom_dimming_factor_${index}`" v-model="system.customDimmingFactor" step="0.05" min="0.05" max="1" />
						{{ system.customDimmingFactor }}
					</div>

        </div>
				<div class="subresults" v-if="computeEnergyConsumption(system) > 0">
          <span class="subresults__title">{{lang.energyconsumption}} (kWh):</span>
					<span class="subresults__value">{{ formatNumber(computeEnergyConsumption(system)) }}</span>

          <span class="subresults__title">{{lang.energycosts}} (CHF):</span>
					<span class="subresults__value">{{ formatNumber(computeEnergyCost(system)) }}</span>

          <span class="subresults__title">CO<sub>2</sub>-{{lang.exhaust}} (kg CO<sub>2</sub>):</span>
					<span class="subresults__value">{{ formatNumber(computeCo2Emissions(system)) }}</span>
        </div>
      </div>
    </section>

		<section class="co2calc__section" v-if="currentStep >= 1">
			<h2 class="co2calc__section-title">{{lang.generalinfos}}</h2>
			<div class="co2calc__general">
				<div class="widget widget--energymix " :class="{ 'custom': energyMix == 0 }">
					<label for="energy_mix">
						<span>{{lang.energymix}} (g CO<sub>2</sub>eq/kWh)</span>
						<a href="https://www.bafu.admin.ch/bafu/de/home/themen/klima/fragen-antworten.html#1369861967" target="_blank" class="inline-link">
							{{ lang.source }} www.bafu.admin.ch
						</a>
					</label>
					<select v-model="energyMix" id="energy_mix">
						<option value="15.7">15.7 g CO₂eq/kWh {{lang.renewablemix}}</option>
						<option value="128">128 g CO₂eq/kWh {{lang.consumermix}}</option>
						<option value="0">{{lang.choose}}</option>
					</select>
					<span class="energymix-hint">Geben Sie ins untenstehende Feld den frei wählbaren Wert ein</span>
					<div class="widget widget-text" v-if="energyMix == 0">
						<input id="custom_energy_mix" v-model="customEnergyMix" type="text" :class="{ 'error': !customEnergyMix }">
						<label for="electricity_cost" >{{ lang.enterco2 }}</label>
					</div>
				</div>
				<div class="widget widget-text">
					<input type="number" min="0" placeholder="." id="light_points" v-model.number="lightPoints" :class="{ 'error': !lightPoints }" />
					<label for="light_points">{{lang.numberoflightpoints}}</label>
				</div>
				<div class="widget widget-text">
					<input type="number" min="0" placeholder="." id="operating_hours" v-model.number="operatingHours" :class="{ 'error': !operatingHours }" />
					<label for="operating_hours">{{lang.operatinghours}}</label>
				</div>
				<div class="widget widget-text">
					<input
						type="number"
						inputmode="decimal"
						min="0"
						step="0.1"
						id="electricity_cost"
						v-model.number="electricityCost"
						:class="{ 'error': !electricityCost }"
					/>
					<label for="electricity_cost">{{ lang.energycostsperkwh }}</label>
				</div>
			</div><br>
			<button @click="scrollToTop" class="button button--primary submit">
			{{ lang.finish }}
		</button>

    </section>
		<div v-if="showOverlay" class="info-popup">
			<div class="info-popup__inner">
				<div class="info-popup__close-container">
				<button class="info-popup__close"
					@click.prevent="toggleOverlay(false)"
				>
					<img src="files/elektron/icons/cross.svg" alt="close" />
				</button>
			</div>
				<div class="info-popup__content">
					<h2>{{lang.dimmingtitletime}}</h2>
					<p>{{lang.dimmingsubtexttime}}</p>
					<img src="files/elektron/images/dimmfaktor2.gif" alt="p dimmfaktor"><br>
					<p>{{lang.dimminginfo}}</p>
					<h2>{{lang.dimmingtitlemovement}}</h2>
					<p>{{lang.dimmingsubtextmovement}}</p>
					<img src="files/elektron/images/dimmfaktor.gif" alt="verkehrsabhängiger dimmfaktor"><br>
					<p>{{lang.dimminginfo}}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  data() {
		const defaults = {
      energyMix: 128,
      customEnergyMix: 29.8,
      lightPoints: 100,
      operatingHours: 4200,
      electricityCost: 0.3,
      timeframe: 10,
      showOverlay: false,
      isSticky: false,
      offset: 400,
      lang: window.lang || {},
      lightingSystems: [
        {
          systemPower: 60,
          dimmingFactor: 1,
          customDimmingFactor: 0.55,
        },
        {
          systemPower: 30,
          dimmingFactor: 1,
          customDimmingFactor: 0.55,
        },
      ],
    };

    return {
      // Defaults als eigene Referenz speichern
      defaults,
      // Dynamische Werte mit Defaults initialisieren
      ...JSON.parse(JSON.stringify(defaults)), // Tiefkopie der Defaults
      currentStep: 1,
    };
  },
  watch: {
    energyMix: "checkStep1",
		customEnergyMix: "checkStep1",
    lightPoints: "checkStep1",
    operatingHours: "checkStep1",
    electricityCost: "checkStep1",
    lightingSystems: {
      handler: "checkStep2",
      deep: true,
    },
  },
  mounted() {
    // Überprüfe beim Laden der Komponente, ob alle Standardwerte gesetzt sind
    this.checkStep1();
    this.checkStep2();
		this.loadParametersFromUrl();
		window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
		hasChanges() {
      const compare = (obj1, obj2) => {
        if (Array.isArray(obj1)) {
          return obj1.some((item, index) => compare(item, obj2[index]));
        } else if (typeof obj1 === "object" && obj1 !== null) {
          return Object.keys(obj1).some(
            (key) => compare(obj1[key], obj2[key])
          );
        } else {
          return obj1 !== obj2;
        }
      };

      return compare(this.defaults, this.$data);
    },
    energyConsumptionDifference() {
      const system1EnergyConsumption = this.computeEnergyConsumption(this.lightingSystems[0]);
      const system2EnergyConsumption = this.computeEnergyConsumption(this.lightingSystems[1]);
      return system1EnergyConsumption - system2EnergyConsumption.toFixed(2);
    },
    energyCostDifference() {
      const system1EnergyCost = this.computeEnergyCost(this.lightingSystems[0]);
      const system2EnergyCost = this.computeEnergyCost(this.lightingSystems[1]);
      return system1EnergyCost - system2EnergyCost.toFixed(2);
    },
    co2EmissionsDifference() {
      const system1Co2Emissions = this.computeCo2Emissions(this.lightingSystems[0]);
      const system2Co2Emissions = this.computeCo2Emissions(this.lightingSystems[1]);
      return system1Co2Emissions - system2Co2Emissions.toFixed(2);
    },
		pathStyleEnergyConsumption() {
			const system1EnergyConsumption = this.computeEnergyConsumption(this.lightingSystems[0]);
			const system2EnergyConsumption = this.computeEnergyConsumption(this.lightingSystems[1]);
			const higherSystemValue = Math.max(system1EnergyConsumption, system2EnergyConsumption);

			if (higherSystemValue === 0) {
				return {
					pathStyle: {
						strokeDasharray: 0,
						strokeDashoffset: 0
					},
					percentage: 0
				};
			}

			const percentage = (this.energyConsumptionDifference / higherSystemValue) * 100;
			const circumference = 2 * Math.PI * 138; // Use a constant radius if needed
			const strokeDashoffset = circumference * (1 - (percentage / 100));

			return {
				pathStyle: {
					strokeDasharray: circumference,
					strokeDashoffset: strokeDashoffset
				},
				percentage: percentage
			};
    },
		pathStyleEnergyCost() {
				const system1EnergyCost = this.computeEnergyCost(this.lightingSystems[0]);
				const system2EnergyCost = this.computeEnergyCost(this.lightingSystems[1]);
				const higherSystemValue = Math.max(system1EnergyCost, system2EnergyCost);

				if (higherSystemValue === 0) {
					return {
						pathStyle: {
							strokeDasharray: 0,
							strokeDashoffset: 0
						},
						percentage: 0
					};
				}

				const percentage = (this.energyCostDifference / higherSystemValue) * 100;
				const circumference = 2 * Math.PI * 138; // Use a constant radius if needed
				const strokeDashoffset = circumference * (1 - (percentage / 100));

				return {
					pathStyle: {
						strokeDasharray: circumference,
						strokeDashoffset: strokeDashoffset
					},
					percentage: percentage
				};
		},
		pathStyleCo2Emissions() {
			const system1Co2Emissions = this.computeCo2Emissions(this.lightingSystems[0]);
			const system2Co2Emissions = this.computeCo2Emissions(this.lightingSystems[1]);
			const higherSystemValue = Math.max(system1Co2Emissions, system2Co2Emissions);

			if (higherSystemValue === 0) {
				return {
					pathStyle: {
						strokeDasharray: 0,
						strokeDashoffset: 0
					},
					percentage: 0
				};
			}

			const percentage = (this.co2EmissionsDifference / higherSystemValue) * 100;
			const circumference = 2 * Math.PI * 138; // Use a constant radius if needed
			const strokeDashoffset = circumference * (1 - (percentage / 100));

			return {
				pathStyle: {
					strokeDasharray: circumference,
					strokeDashoffset: strokeDashoffset
				},
				percentage: percentage
			};
		},
	},
  methods: {
		handleScroll() {
      this.isSticky = window.scrollY > this.offset;
    },
		toggleOverlay(value) {
			document.querySelector("html").classList.toggle("overlay-open")
			this.showOverlay = value;
		},
    computeEnergyConsumption(system) {
      return (
        (this.lightPoints *
          this.operatingHours *
          system.systemPower *
          (system.dimmingFactor > 0 ? system.dimmingFactor : system.customDimmingFactor)
				) /
        1000 *
        this.timeframe
      );
    },
    computeEnergyCost(system) {
      return this.computeEnergyConsumption(system) * this.electricityCost;
    },
    computeCo2Emissions(system) {
      return (
        (this.computeEnergyConsumption(system) * (this.energyMix > 0 ? this.energyMix : this.customEnergyMix)) /
        1000
      );
    },
		formatNumber(value) {
			return new Intl.NumberFormat('de-CH', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			}).format(value);
  	},
    checkStep1() {
      if (
        this.energyMix &&
        this.lightPoints > 0 &&
        this.operatingHours > 0 &&
        this.electricityCost > 0
      ) {
        this.currentStep = Math.max(this.currentStep, 2);
      }
    },
    checkStep2() {
      const validSystems = this.lightingSystems.every(
        (system) => system.systemPower > 0 && (system.dimmingFactor > 0 || system.customDimmingFactor > 0)
      );
      if (validSystems) {
        this.currentStep = Math.max(this.currentStep, 3);
      }
    },
		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		},
		loadParametersFromUrl() {
			const params = new URLSearchParams(window.location.search);

			// Energie-Mix: Wenn vorhanden, nutze den Parameter oder den Custom-Wert, sonst den Default
			const energyMix = parseFloat(params.get('energyMix')) || this.energyMix;
			const customEnergyMix = parseFloat(params.get('customEnergyMix'));

			if (customEnergyMix > 0) {
				this.customEnergyMix = customEnergyMix;  // Setze customEnergyMix, wenn dieser größer als 0 ist
				this.energyMix = 0;
			} else if (energyMix > 0) {
				this.energyMix = energyMix;  // Ansonsten den normalen energyMix
			}

			// Betriebsstunden: Wenn vorhanden, nutze den Parameter oder den Default
			const operatingHours = parseInt(params.get('operatingHours')) || this.operatingHours;
			this.operatingHours = operatingHours;

			//lightPoints
			const lightPoints = parseFloat(params.get('lightPoints')) || this.lightPoints;
			this.lightPoints = lightPoints;

			// Stromkosten: Wenn vorhanden, nutze den Parameter oder den Default
			const electricityCost = parseFloat(params.get('electricityCost')) || this.electricityCost;
			this.electricityCost = electricityCost;

			// Zeitraum: Wenn vorhanden, nutze den Parameter oder den Default
			const timeframe = parseInt(params.get('timeframe')) || this.timeframe;
			this.timeframe = timeframe;

			// Overlay-Status: Wenn vorhanden, nutze den Parameter oder den Default
			const showOverlay = params.get('showOverlay') === 'true';
			this.showOverlay = showOverlay;

			// Sticky-Status: Wenn vorhanden, nutze den Parameter oder den Default
			const isSticky = params.get('isSticky') === 'true';
			this.isSticky = isSticky;

			// Offset: Wenn vorhanden, nutze den Parameter oder den Default
			const offset = parseInt(params.get('offset')) || this.offset;
			this.offset = offset;

			// Beleuchtungssysteme: Wenn vorhanden, nutze die Parameter oder den Default
			this.lightingSystems.forEach((system, index) => {
				const systemPower = parseInt(params.get(`lightingSystem${index + 1}_systemPower`)) || system.systemPower;
				system.systemPower = systemPower;

				const dimmingFactor = parseFloat(params.get(`lightingSystem${index + 1}_dimmingFactor`));
				const customDimmingFactor = parseFloat(params.get(`lightingSystem${index + 1}_customDimmingFactor`)) || system.customDimmingFactor;

				if (customDimmingFactor > 0 && dimmingFactor == 0) {
					system.dimmingFactor = 0;
					system.customDimmingFactor = customDimmingFactor;
				} else if (dimmingFactor > 0) {
					system.dimmingFactor = dimmingFactor;
				}
			});
		},
		generateCurrentUrl() {
			let url = `${window.location.origin}${window.location.pathname}?`;

			// Energie-Mix: nur einfügen, wenn der Wert != default (z.B. 0 oder customEnergyMix != 0)
			if (this.energyMix !== 128 && this.energyMix > 0) {  // Standardwert: 29.8
				url += `energyMix=${this.energyMix}&`;
			} else if (this.customEnergyMix !== 128 && this.customEnergyMix !== 0) {  // Custom-Wert
				url += `customEnergyMix=${this.customEnergyMix}&`;
			}

			// Betriebsstunden: nur einfügen, wenn der Wert != default (z.B. 4200)
			if (this.operatingHours !== 4200) {  // Standardwert: 4200
				url += `operatingHours=${this.operatingHours}&`;
			}

			// Betriebsstunden: nur einfügen, wenn der Wert != default (z.B. 4200)
			if (this.lightPoints !== 100) {  // Standardwert: 4200
				url += `lightPoints=${this.lightPoints}&`;
			}


			// Stromkosten: nur einfügen, wenn der Wert != default (z.B. 0.3)
			if (this.electricityCost !== 0.3) {  // Standardwert: 0.3
				url += `electricityCost=${this.electricityCost}&`;
			}

			// Zeitraum: nur einfügen, wenn der Wert != default (z.B. 10)
			if (this.timeframe !== 10) {  // Standardwert: 10
				url += `timeframe=${this.timeframe}&`;
			}

			// Overlay-Status: nur einfügen, wenn der Wert != default (false)
			if (this.showOverlay !== false) {  // Standardwert: false
				url += `showOverlay=${this.showOverlay}&`;
			}

			// Sticky-Status: nur einfügen, wenn der Wert != default (false)
			if (this.isSticky !== false) {  // Standardwert: false
				url += `isSticky=${this.isSticky}&`;
			}

			// Offset: nur einfügen, wenn der Wert != default (400)
			if (this.offset !== 400) {  // Standardwert: 400
				url += `offset=${this.offset}&`;
			}

			// Füge alle Systemparameter hinzu, die nicht dem Default-Wert entsprechen
			this.lightingSystems.forEach((system, index) => {
				// systemPower: nur einfügen, wenn != default (60 oder 30)
				if (system.systemPower !== 60 && system.systemPower !== 30) {  // Standardwerte: 60 für das erste, 30 für das zweite System
					url += `lightingSystem${index + 1}_systemPower=${system.systemPower}&`;
				}

				// DimmingFactor für jedes System: nur einfügen, wenn != default (1)
				url += `lightingSystem${index + 1}_dimmingFactor=${system.dimmingFactor}&`;

				// CustomDimmingFactor für jedes System: nur einfügen, wenn kein dimming factor existiert
				if (system.customDimmingFactor && system.dimmingFactor == 0) {
					url += `lightingSystem${index + 1}_customDimmingFactor=${system.customDimmingFactor}&`;
				}
			});

			// Entferne das letzte '&' und gib die URL aus
			return url.slice(0, -1);  // Ausgabe der URL
		},

		openRequestform( ){

			let resultUrl = this.generateCurrentUrl();
			const resultForm = document.querySelector('#resultform form');

			// Wähle das Element mit dem Attribut name="result"
			const resultField = document.querySelector('[name="result"]');
			const toggleHandle = document.querySelector('#resulttoggle').click();

			if (toggleHandle) {
				// Klick-Event auslösen
				toggleHandle.click();
			}

			// Ändere den Wert des Feldes
			if (resultField) {
					resultField.value = resultUrl;
			}
		},
  },
};
</script>
